<template>
    <main-content>
        <kt-panel>
            <kt-panel-body v-if="ip_location !== 'IR'">
                <div class="alert alert-danger" role="alert">
                    {{ $t('label.ir_ip_error') }}
                </div>
            </kt-panel-body>
            <kt-panel-body v-else>
                <deposit-form :form_data="form_data" :submit="submit"></deposit-form>
            </kt-panel-body>
        </kt-panel>
    </main-content>
</template>

<script>
import mainContent from '@/components/main-content'
import DepositForm from './components/deposit-form'
import $ from 'jquery'
import {KTApp} from '@/plugins/core/app'
import {depositPfService,depositStarshopService, ipApi} from '@/common/api.service'
import {i18n} from '@/plugins/i18n';
import toastr from "toastr";


export default {
    components: {
        'main-content': mainContent,
        'deposit-form': DepositForm
    },
    data() {
        return {
            ip_location: '',
            phone_validate: false,
            depositPfService,
            depositStarshopService
        }
    },
    mounted() {
        ipApi.ipLocation().then(response => {
            this.ip_location = response.data.countryCode;
        })
    },
    computed: {
        apiService() {
            return this.$route.params.gateway_source === 'pf' ? this.depositPfService : this.depositStarshopService;
        },
        form_data: {
            get: function () {
                return this.$store.state.deposit.form_data
            },
            set: function (value) {
                this.$store.commit('deposit/setFormData', value)
            }
        },
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: false,
                rtl: false
            }
            return toastr
        },
    },
    methods: {
        submit(e) {
            this.form_data.merchant_share_percent = 100;
            let form = $('#deposit_create_form');
            let btn = $('#submit_btn');
            form.validate({
                rules: {
                    farsi_name: {
                        required: true,
                    },
                    english_name: {
                        required: true,
                    },
                    callback_address: {
                        required: true,
                    }
                },
            });
            if (!form.valid()) {
                return
            }

            if (!this.checkIfIsEnglish(this.form_data.english_name)) {
                form.validate().showErrors({
                    english_name: i18n.t('pos.validations.enter_english')
                })
                return;
            }
            if (!this.checkIfIsPersian(this.form_data.farsi_name)) {
                form.validate().showErrors({
                    farsi_name: i18n.t('pos.validations.enter_persian')
                })
                return;
            }

            KTApp.progress(btn);

            let params = this.$store.getters['deposit/form_data'];

            this.apiService.create(params).then(response => {
                this.$router.push('/gateways')
            }).catch(({response}) => {
                if (response.data) {
                    form.validate().showErrors(response.data.data)
                }
                this.showMsg(form, 'danger', response.data.message)
            }).finally(() => {
                KTApp.unprogress(btn)
            })
        },
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.$store.commit('deposit/clearFormData')
        })
    },
}
</script>

<style>

</style>